import React from "react";
import { Box } from "@mui/material";
import colors from "../../themes/colors";

export type StatusColorMap<T extends string | number> = {
  [K in T]: {
    backgroundColor: string;
    textColor: string;
  };
};

export type StatusLabelMap<T extends string | number> = {
  [K in T]: string;
};

export interface StatusChipProps<T extends string | number> {
  status: T;
  colorMap: StatusColorMap<T>;
  labelMap: StatusLabelMap<T>;
}

export const StatusChip = <T extends string | number>({
  status,
  colorMap,
  labelMap
}: StatusChipProps<T>) => {
  const statusColors = colorMap[status] || {
    backgroundColor: colors.secondary.gray96,
    textColor: colors.secondary.gray20
  };
  const label = labelMap[status] || "";

  return (
    <Box
      className="text-14-medium"
      sx={{
        backgroundColor: statusColors.backgroundColor,
        color: statusColors.textColor,
        borderRadius: "4px",
        width: "fit-content",
        padding: "4px 8px"
      }}
    >
      {label}
    </Box>
  );
};
